























import { FlowControlMode } from '@tt4b/ttam-enums';
import { defineComponent, computed } from '@vue/composition-api';
import { PropType } from 'vue';
import { FlowControlModeOptionItem } from '../types';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';

const name = 'ttam-delivery-type-options';

export default defineComponent({
  name,
  components: {
    TooltipInfo,
  },
  props: {
    value: {
      type: Number as PropType<FlowControlMode>,
      default: FlowControlMode.STANDARD,
    },
    options: {
      type: Array as PropType<FlowControlModeOptionItem[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const _flowControlMode = computed({
      get: () => props.value,
      set: val => {
        emit('change', val);
        emit('input', val);
      },
    });
    return {
      name,
      _flowControlMode,
    };
  },
});
